import React from "react";
import { cn } from "@/utils/cn";

interface User {
  firstName?: string;
  lastName?: string;
  profilePicture?: string | null;
}

interface ProfileAvatarProps {
  user?: User | null;
  isOnline?: boolean;
  size?: number;
  className?: string;
}

const ProfileAvatar: React.FC<ProfileAvatarProps> = ({
  user,
  isOnline = false,
  size = 40,
  className,
}) => {
  const firstLetter =
    user?.firstName?.trim()?.charAt(0)?.toUpperCase() ?? "?";

  return (
    <div
      style={{ width: size, height: size }}
      className={cn(
        "relative rounded-full flex items-center justify-center overflow-hidden bg-primary-600 text-white font-semibold select-none",
        className
      )}
    >
      {user?.profilePicture  ? (
        <img
          src={user.profilePicture}
          alt={user.firstName || "User"}
          className="w-full h-full object-cover"
        />
      ) : (
        <span
          style={{ fontSize: size * 0.45 }}
          className="leading-none"
        >
          {firstLetter}
        </span>
      )}

      {/* Online indicator */}
      {isOnline && (
        <span
          className="absolute rounded-full bg-green-500 border-2 border-white"
          style={{
            width: size * 0.25,
            height: size * 0.25,
            bottom: size * 0.05,
            right: size * 0.05,
          }}
        />
      )}
    </div>
  );
};

export default ProfileAvatar;
